import styled from '@emotion/styled';

const EventsWrapper = styled('section')({
  maxWidth: '100%',
  flex: 1,
});

export default EventsWrapper;
